import API from "./api";

/* =========================================================
   TARGET API
   Wraps every /api/targets endpoint used by the new
   Target Management (admin) + My Target (employee) screens.
========================================================= */

/* -------- Employee -------- */

// Employee dashboard: current target + progress + stats + all targets
export const getMyDashboardTarget = () => API.get("/targets/dashboard/me");

// Employee's active "Calls" target (used on the Call Logs page)
export const getMyCallsTarget = () => API.get("/targets/dashboard/calls");

/* -------- Admin -------- */

// Admin dashboard widget: overall target stats
export const getAdminTargetStats = () => API.get("/targets/dashboard/stats");

// Create a new target for a user
export const createTarget = (data) => API.post("/targets/create", data);

// List all targets with search/filter/pagination
// filters: { search, status, target_type, page, limit }
export const listTargets = (filters = {}) =>
  API.get("/targets/manage", { params: filters });

// Get single target details
export const getTargetDetails = (id) => API.get(`/targets/manage/${id}`);

// Update a target
export const updateTarget = (id, data) => API.put(`/targets/manage/${id}`, data);

// Delete a target
export const deleteTarget = (id) => API.delete(`/targets/manage/${id}`);

// Fetch employees eligible for targets (sales executive / telesales)
export const getTargetableUsers = () => API.get("/users");

export default {
  getMyDashboardTarget,
  getMyCallsTarget,
  getAdminTargetStats,
  createTarget,
  listTargets,
  getTargetDetails,
  updateTarget,
  deleteTarget,
  getTargetableUsers,
};
